/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'fabric.elements.mentions.team.member.50plus': "Takım • 50'den fazla üye",
  'fabric.elements.mentions.team.member.50plus.including.you': "Takım • Siz de dahil olmak üzere 50'den fazla üye",
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Takım • 1 üye} other {Takım • {0} üye}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Takım • Siz de dahil olmak üzere 1 üye} other {Takım • Siz de dahil olmak üzere {0} üye}}',
  'fabric.elements.mentions.xproduct.mention.description': "Confluence'a erişim gerekir",
  'fabric.mention.error.defaultAction': 'Birkaç saniye sonra yeniden deneyin',
  'fabric.mention.error.defaultHeadline': 'Bir hata oluştu',
  'fabric.mention.error.differentText': 'Farklı bir metin girmeyi deneyin',
  'fabric.mention.error.loginAgain': 'Oturumu kapatıp yeniden açmayı deneyin',
  'fabric.mention.noAccess.label': 'Erişim izni yok',
  'fabric.mention.noAccess.warning': 'Erişimi olmadığı için {name} adlı kullanıcıya bildirim gönderilmeyecek',
  'fabric.mention.unknow.user.error': 'Bilinmeyen kullanıcı {userId}'
};